import {
  IContractMutations,
  IContractItemUpsertMutationPayload,
  IContractItemViewMutationPayload,
  IContractItemListViewMutationPayload
} from './mutations.types';
import { IContractData, IContractItemData } from '@/models';
import { IContractState } from '../contract.types';

export const mutations: IContractMutations = {
  SET_COUNT(state: IContractState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: IContractState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: IContractState): void {
    state.count -= 1;
  },

  SET_CONTRACTS(state: IContractState, payload: IContractData[]): void {
    state.contracts = payload;
  },

  CONFIRM_CONTRACT_RENEWAL(state: IContractState, payloadId: number): void {
    const contract = state.contracts.find(
      (contract: IContractData) => contract.id === payloadId
    );
    if (contract) {
      const index = state.contracts.indexOf(contract);

      state.contracts.splice(index, 1, {
        ...contract,
        renewal_required: false
      });
    }
  },

  ADD_CONTRACT(state: IContractState, payload: IContractData): void {
    state.contracts.unshift(payload);
  },

  UPDATE_CONTRACT(state: IContractState, payload: IContractData): void {
    const index = state.contracts.findIndex(
      (contract: IContractData) => contract.id === payload.id
    );

    state.contracts.splice(index, 1, payload);
  },

  REMOVE_CONTRACT(state: IContractState, payload: number): void {
    const index = state.contracts.findIndex(
      (contract: IContractData) => contract.id === payload
    );

    state.contracts.splice(index, 1);
  },

  SET_LAST_PROMISE(state: IContractState, payload: Promise<any>): void {
    state.lastPromise = payload;
  },

  SET_CONTRACT_ITEMS_FOR_CONTRACT(
    state: IContractState,
    payload: IContractItemListViewMutationPayload
  ): void {
    const contract = state.contracts.find(
      (contract: IContractData) => contract.id === payload.contractId
    );
    if (contract) {
      contract.items = payload.items;
    }
  },

  UPSERT_CONTRACT_ITEM_IN_CONTRACT(
    state: IContractState,
    payload: IContractItemUpsertMutationPayload
  ): void {
    const contract = state.contracts.find(
      (contract: IContractData) => contract.id === payload.contractId
    );
    if (contract) {
      const itemIndex = contract.items!.findIndex(
        (item: IContractItemData) => item.id === payload.item.id
      );
      if (itemIndex === -1) {
        contract.items!.unshift(payload.item);
      } else {
        // will update reference of contract items
        contract.items!.splice(itemIndex, 1, payload.item);
      }
    }
  },

  REMOVE_CONTRACT_ITEM_FROM_CONTRACT(
    state: IContractState,
    payload: IContractItemViewMutationPayload
  ): void {
    const contract = state.contracts.find(
      (contract: IContractData) => contract.id === payload.contractId
    );
    if (contract) {
      const itemIndex = contract.items!.findIndex(
        (item: IContractItemData) => item.id === payload.itemId
      );
      if (itemIndex !== -1) {
        contract.items!.splice(itemIndex, 1);
      }
    }
  }
};
